import { Address, DataModelEnum, Permission, PermissionAction, RolePermission } from "generated/openApi";
import { store } from "redux/store";

export const normalizePhoneNumber = (phoneNumber?: string | null): string => {
  const digits = phoneNumber?.replace(/\D/g, "") || "";
  return digits.length === 11 && digits.startsWith("1") ? digits.substring(1) : digits;
};

export const isAuthorized = (permission: Permission, permissionAction: PermissionAction): boolean => {
  const rolePermissions: RolePermission[] | undefined = store.getState().app.rolePermissions;

  if (rolePermissions) {
    const rolePermission: RolePermission | undefined = rolePermissions.find((x) => x.permission === permission);

    if (rolePermission && rolePermission.actions?.includes(permissionAction)) {
      return true;
    }
  }

  return false;
};

export const enumToString = (value: DataModelEnum): string => {
  return DataModelEnum[value];
};

export const formatAddress = (address: Address | undefined): string | undefined => {
  if (!address) return undefined;
  if (!address.addressLine && !address.city && !address.state && !address.postal) return undefined;
  return `${address.addressLine ?? "____"}, ${address.city ?? "__"}, ${address.state ?? "__"} ${
    address.postal ?? "__"
  }`;
};
